import { informationUsed } from "@/setting";
import React, { useEffect, useState } from "react";
import EditBuyer from "./EditBuyer";
import EditBuyersAgent from "./EditBuyersAgent";
import { cifFileUpload } from "@/api/placeOffer";
import EditClosingAgent from "./EditClosingAgent";
import EditSubmit from "./EditSubmit";
import EditProofOfFund from "./EditProofOfFund";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { navigateToProperty } from "@/utils/propertyNavigation";

const EditCifBody = ({ state, cifId, documents,formState}) => {
  const [editCifData, setEditCifData] = useState({});
  const [documentDetails, setDocumentDetails] = useState({ pof: "", llc: "" });

  const INITIAL_ACCORDION_STATE = {
    accordion1: { close: false, disable: false, edit: false, visited: false },
    accordion2: { close: true, disable: true, edit: false, visited: false },
    accordion3: { close: true, disable: true, edit: false, visited: false },
    accordion4: { close: true, disable: true, edit: false, visited: false },
    accordion5: { close: true, disable: true, edit: false, visited: false },
  };
  const [success, setSuccessMsg] = useState(false);

  const [accordionState, setAccordionState] = useState(INITIAL_ACCORDION_STATE);
  const navigateToPdp = () => {
    navigateToProperty(`/property/${state?.propertyId}`, state?.propertyCategoryName, state?.propertyStatus);
  };

  const fetchFileConfig = async () => {
    try {
      const listingId = state?.listingId;
      const { status, data } = await cifFileUpload({ listingId });
      if (status === "SUCCESS") {
        setDocumentDetails((prev) => ({
          pof: data?.pofConfig,
          llc: data?.llcConfig,
        }));
      }
    } catch (error) {
      console.error("Error fetching file config:", error);
    }
  };
  useEffect(() => {
    fetchFileConfig();
  }, [state]);

  return (
    <div className="cif-div">
      <div className="close-btn-cif-edit">
        <img
          src="/assets/images/offerCloseIcon.png"
          className="x-btn-offer cursor-pointer"
          alt="close icon"
          onClick={navigateToPdp}
        />
      </div>
      {documents?.errorMessage === "UN_AUTHORIZED_ACCESS" ? (
        <div className="border error-modify">
          Sorry! You are not authorized to access this page as your login
          details do not match with that of the selected bidder. You will be
          redirected to home page.
        </div>
      ) : (
        <div className="border">
          {success ? (
            <>
              <div className="cif-sucess-body text-center p-5 ">
                <div className="hubzu-offer-success-icon pb0">
                  <IoIosCheckmarkCircleOutline size={49} color="#1cbf21" />

                  {/* <FaRegCircleCheck size={49} color="#1cbf21" /> */}
                </div>
                <p className="success_msg pt-3">Success!</p>
                <p className="hubzu-offer-success-submessage pt-1">
                  Information updated successfully. This information will be
                  used for contract documentation.
                </p>
              </div>
            </>
          ) : (
            <>
              <h1 className="cif-heading text-center p-3">
                PROPERTY AND SALE CONTACT INFORMATION
              </h1>
              <section className="property-details">
                <div className="image-div">
                  <img
                    src={
                      state?.propertyImageUrl ===
                      "https://s3.amazonaws.com/hubzu-core-images-dev/frontend/images/no-photo.jpg"
                        ? "/assets/images/imageOnTheWay.webp"
                        : state?.propertyImageUrl ||
                          "/assets/images/imageOnTheWay.webp"
                    }
                    alt="Image on the way"
                  />
                </div>
                <div className="property-data font12 ">
                  <p className="text-wrap add-cif-offer font12">
                    The information contained within this document will be used
                    to complete the contract documentation for the following
                    property:
                  </p>
                  <p className="font12 add-cif-offer">
                    {state?.propertyId || ""}
                  </p>
                  <p className="font12 add-cif-offer">
                    {state?.streetName || ""}, {state?.streetNumber || ""}
                  </p>
                  <p className="font12 add-cif-offer">
                    {state?.city || ""} , {state?.state || ""}
                  </p>
                </div>
              </section>{" "}
              <p className="info-used font12">{informationUsed}</p>
              <div className="cif-data-body">
                <div
                  className="accordion accordion-flush"
                  id="accordionFlushExample"
                >
                  <EditBuyer
                    state={state}
                    editCifData={editCifData}
                    setEditCifData={setEditCifData}
                    setAccordionState={setAccordionState}
                    accordionState={accordionState}
                    //   profileDetails={
                    //     cifFormDetails.userRole === "Buyer" ||
                    //     (cifFormDetails.userRole === "Agent" && !buyerAgent)
                    //       ? profileDetails
                    //       : null
                    //   }
                    llc={documentDetails.llc}
                    //   listingId={listingId}
                    //   buyerAgent={buyerAgent}
                    validateEmail={""}
                    cifId={cifId}
                    documents={documents}
                  />
                  {/* state?.agentOptionalEnabled === "N"  */}
                  {/* {(state?.representedByAgent === "Y" || state?.representedByAgent==null || state?.loggedInUserRole==="BuyerAgent") && ( */}
                  <EditBuyersAgent
                    editCifData={editCifData}
                    setEditCifData={setEditCifData}
                    setAccordionState={setAccordionState}
                    accordionState={accordionState}
                    // profileDetails={
                    //   cifFormDetails.userRole === "Agent" && buyerAgent
                    //     ? profileDetails
                    //     : null
                    // }
                    // state={address?.state}
                    // pof={pof}
                    state={state}
                    validateEmail={editCifData?.buyer?.email}
                    propertyId={state?.propertyId}
                    formState={formState}
                  />
                  {/* )} */}
                  <EditClosingAgent
                    editCifData={editCifData}
                    setEditCifData={setEditCifData}
                    setAccordionState={setAccordionState}
                    accordionState={accordionState}
                    state={state}
                  />
                  {documentDetails?.pof === "Optional" ||
                  documentDetails?.pof === "Required" ? (
                    <EditProofOfFund
                      editCifData={editCifData}
                      setEditCifData={setEditCifData}
                      setAccordionState={setAccordionState}
                      accordionState={accordionState}
                      state={state}
                      pof={documentDetails?.pof}
                      cifId={cifId}
                      documents={documents}
                      setSuccessMsg={setSuccessMsg}
                    />
                  ) : (
                    <EditSubmit
                      editCifData={editCifData}
                      setEditCifData={setEditCifData}
                      setAccordionState={setAccordionState}
                      accordionState={accordionState}
                      state={state}
                      setSuccessMsg={setSuccessMsg}
                      cifId={cifId}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default EditCifBody;
